/**
=========================================================
* Material Dashboard 2 PRO React TS - v1.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-2-pro-react-ts
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import validator from 'validator'
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import Logo from 'assets/images/quizedulogo.png'
import { useState } from "react";

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 PRO React TS components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 PRO React TS examples components
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import PageLayout from "examples/LayoutContainers/PageLayout";

// Material Dashboard 2 PRO React page layout routes
// import pageRoutes from "page.routes";

// Material Dashboard 2 PRO React context
import { List, ListItemButton, ListItemIcon, ListItemText, Typography, useMediaQuery } from '@mui/material';
import MDInput from 'components/MDInput';
import MDButton from 'components/MDButton';
import { Link, useNavigate } from 'react-router-dom';
import { subscribeNewsLetter } from 'services/sendpulse-service';
import { useAppContext } from 'context/app-context';

function NewsLetter(): JSX.Element {

  const navigate = useNavigate()
  const { handleMessage } = useAppContext()

  const isMobile = useMediaQuery('(max-width:499px)')
  const [email, setEmail] = useState('')
  async function handleSubscrtibe(email: string): Promise<void> {
    if (!email || !validator.isEmail(email)) {
      return handleMessage('Du skal skrive en email', 'error')
    }

    await subscribeNewsLetter(email)
    handleMessage('Tak for din tilmelding!', 'success')
    setEmail('')
  }

  return (
    <PageLayout background="#dff5fd">
      <DefaultNavbar
        routes={[]}
        action={{
          type: "internal",
          route: "/authentication/sign-up",
          label: "Få skoleadgang i dag",
          clickButton: () => navigate('/pris'),
          color: "error",
        }}
      />
        <MDBox
          // marginX='auto'
          height="100%"
          paddingTop={isMobile ? 15 : 10}
          overflow='hidden'
        >

          <MDBox

            height={700}
            width='100%'
            sx={{
              backgroundColor: '#dff5fd'
            }}
          >
            <MDBox
              display='flex'
              flexDirection='column'
              justifyContent='center'
              alignItems='center'
              height={700}
              width='fit-content'
              mx='auto'
            >
              <MDTypography fontWeight='regular' variant="h1" textAlign='center' maxWidth={850} width='90vw'>
                Få mest ud fra QuizEdu: få seneste nyt
              </MDTypography>
              <MDTypography variant="p" minWidth={isMobile ? 'calc(100vw - 64px)' : { sm: 400 }} maxWidth={800} textAlign='center' width='90vw'>
                Tilmeld dig QuizEdus nyhedsbrev og bliv opdateret med de nyeste quizzer og nyheder 😀

                Og nåh ja: vær automatisk med i nyhedsbrevskonkurrencerne, hvor du kan vinde lækre præmier 🤩
              </MDTypography>
              <MDBox
                display='flex'
                marginTop={4}
                marginBottom={1}
                gap={2}
                width={isMobile ? 'calc(100vw - 64px)' : 400}
                maxWidth={400}
              >
                <MDInput
                  label="Email"
                  placeholder='Skriv din mailadresse her'
                  style={{
                    backgroundColor: 'white',
                    width: 300,
                    borderRadius: 45
                  }}
                  sx={{
                    borderRadius: 45,
                    '& fieldset': {
                      borderRadius: 45,
                    },
                  }}
                  type='email'
                  value={email}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => setEmail(e.target.value)}
                />
                <MDButton
                  sx={{
                    borderRadius: 45,
                  }}
                  color='error'
                  onClick={() => handleSubscrtibe(email)}
                >Tilmeld</MDButton>
              </MDBox>
            </MDBox>
          </MDBox>

          <MDBox
            sx={{ background: `#dff5fd` }}
          >
            <MDBox
              display='flex'
              flexDirection='column'
              justifyContent='space-between'
              width='100vw'

              maxWidth={1272}
              minWidth={isMobile ? 'fit-content' : 500}
              mx='auto'
            >
              <Grid sx={{ my: 4 }} container spacing={4}>
                <Grid item xs={12} sm={6}>
                  <MDBox
                    mx={isMobile ? 4 : 0}
                    marginLeft={{ xs: 'auto', sm: 4 }}
                    marginRight='auto'
                    width='fit-content'
                    height='fit-content'
                  >
                    <img style={{ marginLeft: isMobile ? 'auto' : 60, marginRight: isMobile ? 'auto' : 32 }} src={Logo} alt='quizedu' width={250} height={'100%'} />
                  </MDBox>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <MDBox
                    mx={isMobile ? 4 : 0}
                    marginRight={{ xs: 'auto', sm: 4 }}
                    marginLeft='auto'
                    width='fit-content'
                    height='fit-content'
                  >
                    <Typography mx={2} component='b' fontWeight={700}>Følg os på:</Typography>
                    <List>
                      <ListItemButton LinkComponent={Link} target='_blank' href='https://www.facebook.com/geekster.dk' sx={{ py: 0 }}>
                        <ListItemIcon sx={{ minWidth: '30px' }}><FacebookIcon /></ListItemIcon>
                        <ListItemText primary="Facebook" />
                      </ListItemButton>
                      <ListItemButton LinkComponent={Link} target='_blank' href='https://www.instagram.com/geekster.dk' sx={{ py: 0 }}>
                        <ListItemIcon sx={{ minWidth: '30px' }}><InstagramIcon /></ListItemIcon>
                        <ListItemText primary="Instagram" />
                      </ListItemButton>
                    </List>
                  </MDBox>
                </Grid>
              </Grid>

              <hr />
              <Typography textAlign={'center'}>{(new Date()).getFullYear()} QuizEdu.dk. Alle rettigheder forbeholdes</Typography>
            </MDBox>
          </MDBox>

        </MDBox>
    </PageLayout>
  );
}


export default NewsLetter;
